if (!customElements.get("save-search-modal")) {
  customElements.define(
    "save-search-modal",
    class SaveSearchModal extends HTMLElement {
      constructor() {
        super();
        this.querySelector("#fp-close-modal").addEventListener("click", () => {
          this.close();
        });
        this.querySelector("#fp-cancel-save").addEventListener("click", () => {
          this.close();
        });
        this.querySelector("form").addEventListener("submit", (event) => {
          this.onSubmit(event);
        });
        this.querySelector("#fp-save-search-name-input").addEventListener("input", (event) => {
          this.validateName(event);
        });
      }

      validateName(event) {
        const input = event.target;
        const submitButton = this.querySelector('button[type="submit"]');
        const maxLength = 140;
        const currentLength = input.value.length;

        if (currentLength >= maxLength) {
          this.displayErrorMessage(`Name cannot exceed ${maxLength} characters`, input, submitButton);
        } else if (currentLength === 0) {
          this.displayErrorMessage("Please enter a saved search name.", input, submitButton);
        } else {
          const errorMessage = document.getElementById("fp-save-search-error");
          if (errorMessage) {
            errorMessage.remove();
          }
          if (submitButton && submitButton.disabled) {
            submitButton.disabled = false;
            submitButton.classList.remove("disabled");
          }
        }
      }

      displayErrorMessage(errorMessageText, input, submitButton) {
        const errorMessage = document.createElement("div");
        errorMessage.id = "fp-save-search-error";
        errorMessage.className = "body-sm";
        errorMessage.style.color = "var(--color-red)";
        errorMessage.style.paddingTop = "0.25rem";
        errorMessage.style.display = "flex";
        errorMessage.style.gap = "0.5rem";
        errorMessage.role = "alert";

        const errorMessageIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path d="M15.8199 13.3872C16.3326 14.2758 15.6891 15.3865 14.665 15.3865H1.33484C0.308813 15.3865 -0.331797 14.274 0.179925 13.3872L6.84509 1.83265C7.35806 0.94365 8.64287 0.945261 9.15492 1.83265L15.8199 13.3872ZM8 10.9983C7.29431 10.9983 6.72223 11.5703 6.72223 12.2759C6.72223 12.9815 7.29431 13.5535 8 13.5535C8.7057 13.5535 9.27778 12.9815 9.27778 12.2759C9.27778 11.5703 8.7057 10.9983 8 10.9983ZM6.78687 6.40607L6.99292 10.1833C7.00256 10.36 7.14873 10.4984 7.32575 10.4984H8.67425C8.85128 10.4984 8.99745 10.36 9.00709 10.1833L9.21314 6.40607C9.22356 6.21516 9.07153 6.05463 8.88031 6.05463H7.11967C6.92845 6.05463 6.77645 6.21516 6.78687 6.40607Z" fill="#eb0008"/>
        </svg>
        `;

        const existingError = this.querySelector("#fp-save-search-error");
        if (existingError) {
          existingError.remove();
        }

        errorMessage.textContent = errorMessageText;

        input.parentNode.insertBefore(errorMessage, input.nextSibling);
        errorMessage.insertAdjacentHTML("afterbegin", errorMessageIcon);
        input.style.border = "0.0625rem solid var(--color-red)";

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add("disabled");
        }
      }

      async onSubmit(event) {
        event.preventDefault();
        const input = document.getElementById("fp-save-search-name-input");
        const submitButton = this.querySelector('button[type="submit"]');

        this.transitionSaveButtonState("pending");

        const formData = new FormData(event.target);

        const data = await this.saveSearch(formData);

        this.transitionSaveButtonState("idle");

        if (data.status === "success") {
          invalidateAllSavedSearches();
          document.querySelectorAll(".fp-save-search-button").forEach((button) => {
            button.setAttribute("disabled", "true");
            button.setAttribute("aria-disabled", "true");
            button.setAttribute("aria-label", "Search saved");
            const copy = button.querySelector(".fp-save-search-copy");
            if (copy) {
              copy.textContent = "Search Saved";
            }
          });
          this.animateHeartIcon();
          this.close();
        } else {
          this.displayErrorMessage(
            "We're having trouble saving your search. Please try again later.",
            input,
            submitButton,
          );
        }
      }

      animateHeartIcon() {
        const heartIcon = document.getElementById("fp-header-following-heart");
        if (heartIcon && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
          heartIcon.classList.remove("heart-pulse");
          void heartIcon.offsetWidth;
          heartIcon.classList.add("heart-pulse");
          const onAnimationEnd = () => {
            heartIcon.classList.remove("heart-pulse");
            heartIcon.removeEventListener("animationend", onAnimationEnd);
          };
          heartIcon.addEventListener("animationend", onAnimationEnd);
        }
      }

      async saveSearch(formData) {
        const body = {
          name: formData.get("name"),
          url: window.location.toString(),
        };

        const token = await window.Clerk.session.getToken();

        const res = await fetch(`${formData.get("web-app-domain")}/saved-search`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Shopify-Shop-Domain": this.sanitizeShopDomain(formData.get("shop-domain")),
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        });

        return await res.json();
      }

      resetForm() {
        const form = this.querySelector("form");
        const submitButton = this.querySelector('button[type="submit"]');
        const errorMessage = this.querySelector("#fp-save-search-error");

        form.reset();
        errorMessage?.remove();

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add("disabled");
          submitButton.innerHTML = "Save";
        }
      }

      close() {
        this.style.setProperty("display", "none");
        this.resetForm();
      }

      convertToInt(arg) {
        if (typeof arg === "string") {
          return parseInt(arg);
        }
        return arg;
      }

      transitionSaveButtonState(state) {
        const saveButton = this.querySelector('button[type="submit"]');

        if (!saveButton) {
          return;
        }

        if (state === "pending") {
          saveButton.disabled = true;
          saveButton.innerHTML = "Saving...";
          saveButton.classList.add("disabled");
        }

        if (state === "idle") {
          saveButton.disabled = false;
          saveButton.innerHTML = "Save";
          saveButton.classList.remove("disabled");
        }
      }

      /*
       * The primary domain does not always match the domain stored in the backend.
       * There's currently no way to consistently determine what that stored domain is,
       * so we've hard-coded the values here. We thought about using
       * `<store name>.myshopify.com` but the store name does not always match the url
       * subdomain.
       */
      sanitizeShopDomain(domain) {
        if (domain === "ecom-www.fashionphile.dev") {
          return "fashionphile-dev.myshopify.com";
        }

        if (domain === "www.staging.fashionphile.com") {
          return "fashionphile-staging.myshopify.com";
        }

        if (domain === "shopify.fashionphile.com" || domain === "www.fashionphile.com") {
          return "9b6844-68.myshopify.com";
        }

        return domain;
      }
    },
  );
}
